import dayjs from "dayjs";
import { PaymentCurrencyEnum } from "./enums";
import { ImUserTie } from "react-icons/im";
import {
  INTRODUCING_BROKER_ACCOUNT_COMMISSION_ROUTE,
  INTRODUCING_BROKER_CLIENT_COMMISSION_ROUTE,
  INTRODUCING_BROKER_COMMISSION_SETTINGS_ROUTE,
  INTRODUCING_BROKER_DASHBOARD_ROUTE,
  INTRODUCING_BROKER_IB_COMMISSIONS_ROUTE,
  INTRODUCING_BROKER_LINKS_ROUTE,
  INTRODUCING_BROKER_PERFORMANCE_DASHBOARD_ROUTE,
  INTRODUCING_BROKER_ROUTE,
} from "./routes";
import { MdOutlineDashboard } from "react-icons/md";
import { LuLink, LuServerCrash, LuSettings2, LuSparkles } from "react-icons/lu";
import { GrCreativeCommons } from "react-icons/gr";
import { TbFileBarcode } from "react-icons/tb";

export const introducingBrokerDefaultParams = {
  currency: PaymentCurrencyEnum.USD,
  from: dayjs().subtract(1, "month").format("YYYY-MM-DD"),
  to: dayjs().format("YYYY-MM-DD"),
};

export const introducingBrokerHomeTabItems = [
  {
    label: "Home",
    icon: <ImUserTie />,
    key: INTRODUCING_BROKER_ROUTE,
  },
  {
    label: "Dashboard",
    icon: <MdOutlineDashboard />,
    key: INTRODUCING_BROKER_DASHBOARD_ROUTE,
  },
  {
    label: "Performance Dashboard",
    icon: <LuSparkles />,
    key: INTRODUCING_BROKER_PERFORMANCE_DASHBOARD_ROUTE,
  },
  {
    label: "IB Commissions",
    icon: <GrCreativeCommons />,
    key: INTRODUCING_BROKER_IB_COMMISSIONS_ROUTE,
  },
  {
    label: "Commission Settings",
    icon: <LuSettings2 />,
    key: INTRODUCING_BROKER_COMMISSION_SETTINGS_ROUTE,
  },
  {
    label: "Links",
    icon: <LuLink />,
    key: INTRODUCING_BROKER_LINKS_ROUTE,
  },
  {
    label: "Account Commission",
    icon: <TbFileBarcode />,
    key: INTRODUCING_BROKER_ACCOUNT_COMMISSION_ROUTE,
  },
  {
    label: "Client Commission",
    icon: <LuServerCrash />,
    key: INTRODUCING_BROKER_CLIENT_COMMISSION_ROUTE,
  },
];
